import {
  BULLET_LIST,
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { TextHelper } from './itemHelpers/TextHelper';
import { ListHelper } from './itemHelpers/ListHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Images3: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'List':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: { side: 'right' },
          items: [
            {
              id: item.id,
              type: LAYOUT_LIST,
              values: { align: 'center' },
              items: [
                {
                  type: TEXT,
                  id: `title_${item.id}`,
                  items: [],
                  values: {
                    value: `${item.title}`,
                    variant: 'heading1'
                  }
                },
                {
                  type: TEXT,
                  id: `subtitle_${item.id}`,
                  items: [],
                  values: {
                    value: item.subtitle,
                    variant: 'sub_heading'
                  }
                },
                {
                  type: BULLET_LIST,
                  id: item.id,
                  values: [],
                  items: ListHelper(item.items)
                }
              ]
            } as LayoutListDefinition
          ]
        } as LayoutHalfPageDefinition;
      case 'Text':
        // case 'TEXT':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: { side: 'right' },
          items: TextHelper(item as ItemOfType<'Text'>)
        };
      default:
        return null;
    }
  });
};
